import hero_img7 from "../assets/images/hero_img7.jpeg";

import per_1 from "../assets/images/per_1.jpeg";
import per_2 from "../assets/images/per_2.jpeg";
import per_3 from "../assets/images/per_3.jpeg";
import per_4 from "../assets/images/per_4.jpeg";
import per_5 from "../assets/images/per_5.jpeg";

import risk_1 from "../assets/images/risk_1.jpeg";
import risk_2 from "../assets/images/risk_2.jpeg";
import risk_3 from "../assets/images/risk_3.jpeg";
import risk_4 from "../assets/images/risk_4.jpeg";
import risk_5 from "../assets/images/risk_5.jpeg";

import est_1 from "../assets/images/est_1.jpeg";
import est_2 from "../assets/images/est_2.jpeg";
import est_3 from "../assets/images/est_3.jpeg";
import est_4 from "../assets/images/est_4.jpeg";
import est_5 from "../assets/images/est_5.jpeg";

import inv_1 from "../assets/images/inv_1.jpeg";
import inv_2 from "../assets/images/inv_2.jpeg";

import ins_1 from "../assets/images/ins_1.jpeg";
import ins_2 from "../assets/images/ins_2.jpeg";
import ins_3 from "../assets/images/ins_3.jpeg";

const course_images = {
    per_1, per_2, per_3, per_4, per_5,
    risk_1, risk_2, risk_3, risk_4, risk_5,
    est_1, est_2, est_3, est_4, est_5,
    inv_1, inv_2,
    ins_1, ins_2, ins_3
  };

const other_images = {hero_img7};

/*const categories_images = [cat_python, cat_web_development,  cat_data_science, cat_aws, cat_design, cat_marketing ];*/

export {course_images, other_images};